export default __webpack_public_path__ + "fonts/TwemojiCountryFlags.e40fbca868d3568f1b57f35c54c177b1.woff2";